module.exports = __webpack_public_path__ + "img/pdf_icon.63536671.svg";